module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.108/js/sprocket_orange.svg"